module.exports = __webpack_public_path__ + "img/内圈.d01ff7e4.png";